var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.479,21.335h.005V13.96c0-3.607-.777-6.386-4.994-6.386a4.378,4.378,0,0,0-3.943,2.167h-.059V7.911h-4V21.334h4.164V14.687c0-1.75.332-3.442,2.5-3.442,2.135,0,2.167,2,2.167,3.555v6.535Z","transform":"translate(-1.377 -1.229)","key":0}),React.createElement("path",{"d":"M.4,7.977H4.565V21.4H.4Z","transform":"translate(-0.064 -1.294)","key":1}),React.createElement("path",{"d":"M2.414,0A2.426,2.426,0,1,0,4.829,2.414,2.415,2.415,0,0,0,2.414,0Z","key":2})]);
}

Linkedin.defaultProps = {"width":"20.106","height":"20.106","fill":"currentColor","viewBox":"0 0 20.106 20.106"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
